<div class="d-flex flex-column justify-content-start text-left">
  <div style="display: flex;
    align-items: baseline; justify-content: center;" [dir]="languageService.dir | async">
    <p-checkbox funcDebounce [(ngModel)]="_checked" binary="true" [delay]="0" [func]="'onChange'"
      (debounceFunc)="onChange($event)" [disabled]="disabled"></p-checkbox>
    <span class='red'>*</span><span [innerHTML]="'Account.EULA' | translate"></span>
  </div>
  <br>
</div>